// src/shared/utils/getFileUrl.js

import { ImagePathNode } from "../constants";

 
// Example: export const ImagePathNode = import.meta.env.VITE_API_BASE;

export function getFileUrl(src) {
  if (!src) return '';

  // If already a full absolute URL (external or CDN)
  if (/^https?:\/\//i.test(src)) {
    return src;
  }

  // Common backend-served folders — customize as needed
  const backendFolders = [
    '/uploads',   // images or general files
    '/pdfs',      // PDFs
    '/audios',    // audio files
    '/videos',    // video files
    '/docs',      // extra docs if any
  ];

  // If it starts with one of the backend paths, prepend the base node URL
  const isBackendPath = backendFolders.some(folder => src.startsWith(folder));
  if (isBackendPath) {
    return `${ImagePathNode}${src}`;
  }

  // Otherwise, return unchanged (local/public file)
  return src;
}
